import { render, staticRenderFns } from "./BoxwrapHeader.vue?vue&type=template&id=9d1d871a"
import script from "./BoxwrapHeader.vue?vue&type=script&lang=js"
export * from "./BoxwrapHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports